import * as React from 'react';
import * as styles from './styles.css';

export interface ITabContentProps {
  children: React.ReactNode;
}

export function TabContent({ children }: ITabContentProps) {
  return <div className={styles['container']}>{children}</div>;
}
